// @core/api/endpoints/billing/void_invoice.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VoidInvoiceRequest,
  VoidInvoiceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Void invoice
 * Voids a finalized invoice, making it uncollectible. Creates reversing journal entries if the invoice was already recorded in the ledger.
 */
export async function VoidInvoice(
  id: string,
  data: VoidInvoiceRequest,
  options?: RequestOptions
): Promise<VoidInvoiceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invoices/:id/void`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<VoidInvoiceResponse>(requestPath, data, requestOptions);
}
